import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MessageTemplateStatusForm from '../../../components/forms/MessageTemplateStatusForm';
import { useMessageTemplateStatusApi } from '../../../hooks/useMessageTemplateStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MessageTemplateStatusDTO } from '../../../services/apiClient';

const MessageTemplateStatusEdit: React.FC = () => {
  const { getById, edit, isLoading } = useMessageTemplateStatusApi();
  const [entityData, setEntityData] = useState<MessageTemplateStatusDTO | null>(
    null,
  );
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    {
      label: 'Message Template Statuses',
      href: '/admin/messagetemplatestatuses',
    },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching MessageTemplateStatus data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/messagetemplatestatuses');
    } catch (error) {
      console.error('Error updating MessageTemplateStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/messagetemplatestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MessageTemplateStatus.Edit"
    >
        {entityData ? (
          <MessageTemplateStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/messagetemplatestatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MessageTemplateStatusEdit;
